import React, { Fragment, memo } from "react";
import PropTypes from "prop-types";

import Backdrop from "../../atoms/Backdrop/Backdrop";

import "./Modal.scss";

const modal = ({ show, modalClosed, children }) => (
  <Fragment>
    <Backdrop show={show} clicked={modalClosed} />
    <div
      className="modal"
      style={{
        transform: show ? `translateY(0)` : `translateY(-100vh)`,
        opacity: show ? `1` : `0`,
      }}
    >
      {children}
    </div>
  </Fragment>
);

modal.propTypes = {
  show: PropTypes.bool,
  modalClosed: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default memo(
  modal,
  (prevProps, nextProps) =>
    nextProps.show === prevProps.show &&
    nextProps.children === prevProps.children
);
